import React from "react";
import RetrievalAttorneyInformationBase from "./RetrievalAttorneyInformationBase";
import { RETRIEVAL_ATTORNEY_CONFIG } from "../retrievalAttorneyConfig";
import { RETRIEVE_GLOBAL_DATA_ROLE_DISABLED } from "./bondRetrieveSharedPropTypes";

const ProbateAttorneyInformation = ({ globalData, data, updateData, role, isDisabled }) => (
  <RetrievalAttorneyInformationBase
    cfg={RETRIEVAL_ATTORNEY_CONFIG.probate}
    globalData={globalData}
    data={data}
    updateData={updateData}
    role={role}
    isDisabled={isDisabled}
  />
);

ProbateAttorneyInformation.propTypes = RETRIEVE_GLOBAL_DATA_ROLE_DISABLED;

export default ProbateAttorneyInformation;
